export default {
  meta: {
    title: $localize`:@@meta.mines.title:Минёр CS2 CSFAIL - Mines CSGO`,
    description: $localize`:@@meta.mines.desc:Играйте в игру Mines на CSFAIL и испытайте удачу, избегая мин. Выигрывайте ценные призы и наслаждайтесь захватывающим игровым процессом в CS2.`
  }
};